import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';

// eslint-disable-next-line import/no-unused-modules
export const getActiveDetailedInformationTab = ({ detailedInformation }) => {
    return detailedInformation?.activeTab;
};
// eslint-disable-next-line import/no-unused-modules
export const getSelectedAsset = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAsset;
};

const getConditionInsightsError = ({ assetConditionInsights }) => {
    return {
        loadingStatus: assetConditionInsights?.loadingStatus,
        error: assetConditionInsights?.error,
        errorCode: assetConditionInsights?.error?.statusCode
    };
};

const getConditionInsightsErrorData = createErrorDataSelector(getConditionInsightsError);

const getAssetDetails = ({ detailedInformation }) => {
    return {
        loadingStatus: detailedInformation?.assetDetails?.loadingStatus,
        details: detailedInformation?.assetDetails?.data?.details,
        id: detailedInformation?.assetDetails?.data?.id
    };
};

const getSensorProperties = ({ sensorProperties }) => {
    return sensorProperties?.sensorProperties;
};

const getAssetConditionInsights = ({ assetConditionInsights }) => {
    return {
        loadingStatus: assetConditionInsights?.loadingStatus,
        data: assetConditionInsights?.data,
        error: assetConditionInsights?.error,
        trendKPI: assetConditionInsights?.conditionInsightsTrendKpis?.trendKPI,
        driveKPI: assetConditionInsights?.conditionInsightsDriveStatus?.driveKPI?.[0],
        anomalyDetectionKPI: assetConditionInsights?.conditionInsightsTrendKpis?.anomalyDetectionKPI,
        overAllStatus: assetConditionInsights?.assetInfo?.conditionStatus,
        isZoomed: assetConditionInsights?.zoom?.isZoomed,
        driveAnomalyActiveTab: assetConditionInsights?.driveAnomalyActiveTab,
        showConditionForecast: assetConditionInsights?.showConditionForecast,
    };
};

const getActiveTab = ({ assetConditionInsights }) => {
    return assetConditionInsights?.activeTab;
};

const getSelectedAssetV2 = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.selectedAsset;
};

const getKpiFromSummary = ({ assetConditionInsights }) => {
    return assetConditionInsights?.kpiFromSummary;
};

/*export const getActiveTab = ({ operationalParameters }) => {
    return operationalParameters?.activeTab;
};*/
// eslint-disable-next-line import/no-unused-modules
export const getModel = createSelector([
    getActiveTab,
    getAssetDetails,
    getSensorProperties,
    getAssetConditionInsights,
    getConditionInsightsErrorData,
    getSelectedAssetV2,
    getKpiFromSummary
], (
    activeTab,
    assetDetails,
    sensorProperties,
    conditionInsights,
    conditionInsightsErrorData,
    selectedAsset,
    kpiFromSummary
) => {
    return {
        activeTab,
        assetDetails,
        sensorProperties,
        conditionInsights,
        conditionInsightsErrorData,
        selectedAsset,
        kpiFromSummary
    };
});
